
module dgUtils {

    export interface IStringularFilter extends Function {
        (value: string, ...args: any[]): string;
    }

    export interface IToArrayFilter extends Function {
        (value: any, addKey?: boolean): Array<any>;
    }
}